<div *ngIf="!!control" class="form-group position-relative">
  <div class="input-group d-flex justify-content-center" [class.is-invalid]="control.touched && control.errors">
    <input
      numbersOnly
      class="form-control width-80"
      [formControl]="control"
      [class.is-invalid]="control.touched && control.errors"
      (blur)="onBlur($event)"
    />
    <button [disabled]="control.disabled || control.value >= maxQuantity" (click)="changeQuantityVal(QuantityInputAction.Increase)" class="btn btn-primary">
      <i class="mdi mdi-plus-thick"></i>
    </button>
    <button [disabled]="control.disabled || control.value <= minQuantity" (click)="changeQuantityVal(QuantityInputAction.Decrease)" class="btn btn-light" type="button">
      <i class="mdi mdi-minus-thick"></i>
    </button>
  </div>

  <app-form-field-error
    *ngIf="control.touched && !control.valid"
    [label]="label"
    [errors]="control.errors"
    class="{{ errorClassList }}"
  ></app-form-field-error>
</div>
